import React, { useState } from "react";
import "./footerItems.css";
const FooterItems = ({
  imageYellow,
  imageWhite,
  label,
  onClick,
  addKit,
  disable,
  onClicked,
  enableReset,
  buttonLabel,
  clickable,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Function to handle mouse over event
  const handleMouseOver = () => {
    setIsHovered(true);
  };

  // Function to handle mouse out event
  const handleMouseOut = () => {
    setIsHovered(false);
  };

  return (
    <div className="footer-items">
      <div
        className="footer_button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          pointerEvents: clickable && !addKit && "none",
          width: buttonLabel ? "14rem" : "4rem",
          height: buttonLabel ? "4rem" : "4rem",
          opacity: disable && !addKit ? (enableReset ? undefined : 0.5) : "",
          // backgroundColor: isHovered && buttonLabel && "#FFE100",
          // border: ((disable && !addKit) || onClicked) && "1.5px solid #555555",
          border:
            buttonLabel && !isHovered
              ? "1px solid #bcbec0"
              : buttonLabel && isHovered && "0.19rem solid #FFE100",
          backgroundColor: buttonLabel && "rgba(0, 0, 0, 0.17)",
          boxShadow:
            (disable && !addKit) || onClicked
              ? "0rem 0.5rem 0.375rem rgba(0, 0, 0, 0.3)"
              : enableReset && "0rem 0.25rem 0.1875rem rgba(0, 0, 0, 0.2)",
          borderRadius: ((disable && !addKit) || onClicked) && "1.25rem",
          margin: "0 2rem 0 2rem",
        }}
        onClick={onClick}
      >
        {(imageYellow || imageWhite) && (
          <img
            className="footer_icon"
            src={isHovered || onClicked ? imageYellow : imageWhite}
            alt="footer"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            onClick={() => setIsHovered(false)}
          />
        )}
        {buttonLabel && (
          <div className="configurator_text boldFont">{buttonLabel}</div>
        )}
      </div>
      {label && (
        <p
          className="footer-label boldFont"
          style={{
            color: onClicked && "#FFE100",
          }}
        >
          {label}
        </p>
      )}
    </div>

    // <div className="footer-items">
    //   <div
    //     className="footer-button"
    //     style={{
    //       pointerEvents: clickable && !addKit && "none",
    //       width: buttonLabel ? "14rem" : "4rem",
    //       height: buttonLabel ? "4rem" : "4rem",
    //       background:
    //         disable && !addKit
    //           ? enableReset
    //             ? undefined
    //             : "#D9D9D9"
    //           : onClicked && "#FFE100",
    //       border: ((disable && !addKit) || onClicked) && "1.5px solid #555555",

    //       boxShadow:
    //         (disable && !addKit) || onClicked
    //           ? "0rem 0.5rem 0.375rem rgba(0, 0, 0, 0.3)"
    //           : enableReset && "0rem 0.25rem 0.1875rem rgba(0, 0, 0, 0.2)",
    //       borderRadius: ((disable && !addKit) || onClicked) && "1.25rem",
    //       margin: "0 2rem 0 2rem",
    //     }}
    //     onClick={onClick}
    //   >
    //     {image && <img className="footer-icon" src={image} alt="footer" />}
    //     {buttonLabel && (
    //       <div className="configurator-text boldFont">{buttonLabel}</div>
    //     )}
    //   </div>
    //   {label && (
    //     <p
    //       className="footer-label boldFont"
    //       style={{
    //         color: onClicked && "#FFE100",
    //       }}
    //     >
    //       {label}
    //     </p>
    //   )}
    // </div>
  );
};

export default FooterItems;
